import { render, staticRenderFns } from "./SupplierLocations.vue?vue&type=template&id=5ca606dc&"
import script from "./SupplierLocations.vue?vue&type=script&lang=js&"
export * from "./SupplierLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports